import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query'
import { TUseMutationOptions, TUseQueryOptions, TCustomUseQueryMeta } from 'core/query/type'
import {
  TPostWalletChainSupportedChainsParams,
  TPostWalletChainSupportedChainsResponse,
  postWalletChainSupportedChains,
  TPostWalletTokenCurrentPriceParams,
  TPostWalletTokenCurrentPriceResponse,
  postWalletTokenCurrentPrice,
  TPostWalletTokenRealTimePriceParams,
  TPostWalletTokenRealTimePriceResponse,
  postWalletTokenRealTimePrice,
  TPostWalletTokenHistoricalPriceParams,
  TPostWalletTokenHistoricalPriceResponse,
  postWalletTokenHistoricalPrice,
  TPostWalletTokenTokenDetailParams,
  TPostWalletTokenTokenDetailResponse,
  postWalletTokenTokenDetail,
  TPostWalletAssetTotalValueByAddressParams,
  TPostWalletAssetTotalValueByAddressResponse,
  postWalletAssetTotalValueByAddress,
  TPostWalletAssetAllTokenBalancesByAddressParams,
  TPostWalletAssetAllTokenBalancesByAddressResponse,
  postWalletAssetAllTokenBalancesByAddress,
  TPostWalletAssetTokenBalancesByAddressParams,
  TPostWalletAssetTokenBalancesByAddressResponse,
  postWalletAssetTokenBalancesByAddress,
  TPostWalletUtxoUtxosParams,
  TPostWalletUtxoUtxosResponse,
  postWalletUtxoUtxos,
  TPostWalletUtxoUtxoDetailParams,
  TPostWalletUtxoUtxoDetailResponse,
  postWalletUtxoUtxoDetail,
  TPostWalletSecurityApprovalsParams,
  TPostWalletSecurityApprovalsResponse,
  postWalletSecurityApprovals,
  TPostWalletAssetTotalValueParams,
  TPostWalletAssetTotalValueResponse,
  postWalletAssetTotalValue,
  TPostWalletAssetWalletAllTokenBalancesParams,
  TPostWalletAssetWalletAllTokenBalancesResponse,
  postWalletAssetWalletAllTokenBalances,
  TPostWalletAssetTokenBalancesParams,
  TPostWalletAssetTokenBalancesResponse,
  postWalletAssetTokenBalances,
  TPostWalletPostTransactionTransactionsByAddressParams,
  TPostWalletPostTransactionTransactionsByAddressResponse,
  postWalletPostTransactionTransactionsByAddress,
  TPostWalletPostTransactionTransactionsParams,
  TPostWalletPostTransactionTransactionsResponse,
  postWalletPostTransactionTransactions,
  TPostWalletPostTransactionTransactionDetailByTxhashParams,
  TPostWalletPostTransactionTransactionDetailByTxhashResponse,
  postWalletPostTransactionTransactionDetailByTxhash,
  TPostWalletPostTransactionInscriptionTransactionDetailByTxhashParams,
  TPostWalletPostTransactionInscriptionTransactionDetailByTxhashResponse,
  postWalletPostTransactionInscriptionTransactionDetailByTxhash,
  TPostWalletAccountCreateWalletAccountParams,
  TPostWalletAccountCreateWalletAccountResponse,
  postWalletAccountCreateWalletAccount,
  TPostWalletAccountUpdateWalletAccountParams,
  TPostWalletAccountUpdateWalletAccountResponse,
  postWalletAccountUpdateWalletAccount,
  TPostWalletAccountDeleteAccountParams,
  TPostWalletAccountDeleteAccountResponse,
  postWalletAccountDeleteAccount,
  TPostWalletAccountAccountsParams,
  TPostWalletAccountAccountsResponse,
  postWalletAccountAccounts,
  TPostWalletAccountAccountDetailParams,
  TPostWalletAccountAccountDetailResponse,
  postWalletAccountAccountDetail,
  TPostWalletPreTransactionSignInfoParams,
  TPostWalletPreTransactionSignInfoResponse,
  postWalletPreTransactionSignInfo,
  TPostWalletPreTransactionGasPriceParams,
  TPostWalletPreTransactionGasPriceResponse,
  postWalletPreTransactionGasPrice,
  TPostWalletPreTransactionGasLimitParams,
  TPostWalletPreTransactionGasLimitResponse,
  postWalletPreTransactionGasLimit,
  TPostWalletPreTransactionNonceParams,
  TPostWalletPreTransactionNonceResponse,
  postWalletPreTransactionNonce,
  TPostWalletPreTransactionSuiObjectParams,
  TPostWalletPreTransactionSuiObjectResponse,
  postWalletPreTransactionSuiObject,
  TPostWalletPreTransactionValidateAddressParams,
  TPostWalletPreTransactionValidateAddressResponse,
  postWalletPreTransactionValidateAddress,
  TPostWalletPreTransactionBroadcastTransactionParams,
  TPostWalletPreTransactionBroadcastTransactionResponse,
  postWalletPreTransactionBroadcastTransaction,
  TPostWalletPostTransactionOrdersParams,
  TPostWalletPostTransactionOrdersResponse,
  postWalletPostTransactionOrders,
} from 'core/service/yapi/web3/wallet/api'
// wallet
// 查询支持的区块链
export const usePostWalletChainSupportedChainsMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostWalletChainSupportedChainsResponse,
    TPostWalletChainSupportedChainsParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletChainSupportedChains', 'Post'],
    mutationFn: (params?: TPostWalletChainSupportedChainsParams) =>
      postWalletChainSupportedChains(params, mutationOptions?.meta?.requestOptions),
  })
}

// 综合币价
export const usePostWalletTokenCurrentPriceMutation = (
  mutationOptions?: TUseMutationOptions<TPostWalletTokenCurrentPriceResponse, TPostWalletTokenCurrentPriceParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletTokenCurrentPrice', 'Post'],
    mutationFn: (params?: TPostWalletTokenCurrentPriceParams) =>
      postWalletTokenCurrentPrice(params, mutationOptions?.meta?.requestOptions),
  })
}

// 实时币价
export const usePostWalletTokenRealTimePriceMutation = (
  mutationOptions?: TUseMutationOptions<TPostWalletTokenRealTimePriceResponse, TPostWalletTokenRealTimePriceParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletTokenRealTimePrice', 'Post'],
    mutationFn: (params?: TPostWalletTokenRealTimePriceParams) =>
      postWalletTokenRealTimePrice(params, mutationOptions?.meta?.requestOptions),
  })
}

// 历史币价
export const usePostWalletTokenHistoricalPriceMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostWalletTokenHistoricalPriceResponse,
    TPostWalletTokenHistoricalPriceParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletTokenHistoricalPrice', 'Post'],
    mutationFn: (params?: TPostWalletTokenHistoricalPriceParams) =>
      postWalletTokenHistoricalPrice(params, mutationOptions?.meta?.requestOptions),
  })
}

// 项目信息
export const usePostWalletTokenTokenDetailMutation = (
  mutationOptions?: TUseMutationOptions<TPostWalletTokenTokenDetailResponse, TPostWalletTokenTokenDetailParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletTokenTokenDetail', 'Post'],
    mutationFn: (params?: TPostWalletTokenTokenDetailParams) =>
      postWalletTokenTokenDetail(params, mutationOptions?.meta?.requestOptions),
  })
}

// 地址总估值
export const usePostWalletAssetTotalValueByAddressMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostWalletAssetTotalValueByAddressResponse,
    TPostWalletAssetTotalValueByAddressParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletAssetTotalValueByAddress', 'Post'],
    mutationFn: (params?: TPostWalletAssetTotalValueByAddressParams) =>
      postWalletAssetTotalValueByAddress(params, mutationOptions?.meta?.requestOptions),
  })
}

// 地址资产明细
export const usePostWalletAssetAllTokenBalancesByAddressMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostWalletAssetAllTokenBalancesByAddressResponse,
    TPostWalletAssetAllTokenBalancesByAddressParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletAssetAllTokenBalancesByAddress', 'Post'],
    mutationFn: (params?: TPostWalletAssetAllTokenBalancesByAddressParams) =>
      postWalletAssetAllTokenBalancesByAddress(params, mutationOptions?.meta?.requestOptions),
  })
}

// 地址 查询特定代币
export const usePostWalletAssetTokenBalancesByAddressMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostWalletAssetTokenBalancesByAddressResponse,
    TPostWalletAssetTokenBalancesByAddressParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletAssetTokenBalancesByAddress', 'Post'],
    mutationFn: (params?: TPostWalletAssetTokenBalancesByAddressParams) =>
      postWalletAssetTokenBalancesByAddress(params, mutationOptions?.meta?.requestOptions),
  })
}

// 地址 查询持有的 UTXO
export const usePostWalletUtxoUtxosMutation = (
  mutationOptions?: TUseMutationOptions<TPostWalletUtxoUtxosResponse, TPostWalletUtxoUtxosParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletUtxoUtxos', 'Post'],
    mutationFn: (params?: TPostWalletUtxoUtxosParams) =>
      postWalletUtxoUtxos(params, mutationOptions?.meta?.requestOptions),
  })
}

// 地址 查 UTXO 上铭文
export const usePostWalletUtxoUtxoDetailMutation = (
  mutationOptions?: TUseMutationOptions<TPostWalletUtxoUtxoDetailResponse, TPostWalletUtxoUtxoDetailParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletUtxoUtxoDetail', 'Post'],
    mutationFn: (params?: TPostWalletUtxoUtxoDetailParams) =>
      postWalletUtxoUtxoDetail(params, mutationOptions?.meta?.requestOptions),
  })
}

// 地址 查询授权
export const usePostWalletSecurityApprovalsMutation = (
  mutationOptions?: TUseMutationOptions<TPostWalletSecurityApprovalsResponse, TPostWalletSecurityApprovalsParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletSecurityApprovals', 'Post'],
    mutationFn: (params?: TPostWalletSecurityApprovalsParams) =>
      postWalletSecurityApprovals(params, mutationOptions?.meta?.requestOptions),
  })
}

// 账户 总估值
export const usePostWalletAssetTotalValueMutation = (
  mutationOptions?: TUseMutationOptions<TPostWalletAssetTotalValueResponse, TPostWalletAssetTotalValueParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletAssetTotalValue', 'Post'],
    mutationFn: (params?: TPostWalletAssetTotalValueParams) =>
      postWalletAssetTotalValue(params, mutationOptions?.meta?.requestOptions),
  })
}

// 账户 资产明细
export const usePostWalletAssetWalletAllTokenBalancesMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostWalletAssetWalletAllTokenBalancesResponse,
    TPostWalletAssetWalletAllTokenBalancesParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletAssetWalletAllTokenBalances', 'Post'],
    mutationFn: (params?: TPostWalletAssetWalletAllTokenBalancesParams) =>
      postWalletAssetWalletAllTokenBalances(params, mutationOptions?.meta?.requestOptions),
  })
}

// 账户 查询特定代币
export const usePostWalletAssetTokenBalancesMutation = (
  mutationOptions?: TUseMutationOptions<TPostWalletAssetTokenBalancesResponse, TPostWalletAssetTokenBalancesParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletAssetTokenBalances', 'Post'],
    mutationFn: (params?: TPostWalletAssetTokenBalancesParams) =>
      postWalletAssetTokenBalances(params, mutationOptions?.meta?.requestOptions),
  })
}

// 地址维度查询
export const usePostWalletPostTransactionTransactionsByAddressMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostWalletPostTransactionTransactionsByAddressResponse,
    TPostWalletPostTransactionTransactionsByAddressParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletPostTransactionTransactionsByAddress', 'Post'],
    mutationFn: (params?: TPostWalletPostTransactionTransactionsByAddressParams) =>
      postWalletPostTransactionTransactionsByAddress(params, mutationOptions?.meta?.requestOptions),
  })
}

// 账户维度查询
export const usePostWalletPostTransactionTransactionsMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostWalletPostTransactionTransactionsResponse,
    TPostWalletPostTransactionTransactionsParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletPostTransactionTransactions', 'Post'],
    mutationFn: (params?: TPostWalletPostTransactionTransactionsParams) =>
      postWalletPostTransactionTransactions(params, mutationOptions?.meta?.requestOptions),
  })
}

// 查询特定 Tx
export const usePostWalletPostTransactionTransactionDetailByTxhashMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostWalletPostTransactionTransactionDetailByTxhashResponse,
    TPostWalletPostTransactionTransactionDetailByTxhashParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletPostTransactionTransactionDetailByTxhash', 'Post'],
    mutationFn: (params?: TPostWalletPostTransactionTransactionDetailByTxhashParams) =>
      postWalletPostTransactionTransactionDetailByTxhash(params, mutationOptions?.meta?.requestOptions),
  })
}

// 查询铭文交易
export const usePostWalletPostTransactionInscriptionTransactionDetailByTxhashMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostWalletPostTransactionInscriptionTransactionDetailByTxhashResponse,
    TPostWalletPostTransactionInscriptionTransactionDetailByTxhashParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletPostTransactionInscriptionTransactionDetailByTxhash', 'Post'],
    mutationFn: (params?: TPostWalletPostTransactionInscriptionTransactionDetailByTxhashParams) =>
      postWalletPostTransactionInscriptionTransactionDetailByTxhash(params, mutationOptions?.meta?.requestOptions),
  })
}

// 创建账户
export const usePostWalletAccountCreateWalletAccountMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostWalletAccountCreateWalletAccountResponse,
    TPostWalletAccountCreateWalletAccountParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletAccountCreateWalletAccount', 'Post'],
    mutationFn: (params?: TPostWalletAccountCreateWalletAccountParams) =>
      postWalletAccountCreateWalletAccount(params, mutationOptions?.meta?.requestOptions),
  })
}

// 更新账户
export const usePostWalletAccountUpdateWalletAccountMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostWalletAccountUpdateWalletAccountResponse,
    TPostWalletAccountUpdateWalletAccountParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletAccountUpdateWalletAccount', 'Post'],
    mutationFn: (params?: TPostWalletAccountUpdateWalletAccountParams) =>
      postWalletAccountUpdateWalletAccount(params, mutationOptions?.meta?.requestOptions),
  })
}

// 删除账户
export const usePostWalletAccountDeleteAccountMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostWalletAccountDeleteAccountResponse,
    TPostWalletAccountDeleteAccountParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletAccountDeleteAccount', 'Post'],
    mutationFn: (params?: TPostWalletAccountDeleteAccountParams) =>
      postWalletAccountDeleteAccount(params, mutationOptions?.meta?.requestOptions),
  })
}

// 查询账户
export const usePostWalletAccountAccountsMutation = (
  mutationOptions?: TUseMutationOptions<TPostWalletAccountAccountsResponse, TPostWalletAccountAccountsParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletAccountAccounts', 'Post'],
    mutationFn: (params?: TPostWalletAccountAccountsParams) =>
      postWalletAccountAccounts(params, mutationOptions?.meta?.requestOptions),
  })
}

// 查询账户下的地址
export const usePostWalletAccountAccountDetailMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostWalletAccountAccountDetailResponse,
    TPostWalletAccountAccountDetailParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletAccountAccountDetail', 'Post'],
    mutationFn: (params?: TPostWalletAccountAccountDetailParams) =>
      postWalletAccountAccountDetail(params, mutationOptions?.meta?.requestOptions),
  })
}

// 签名所需数据
export const usePostWalletPreTransactionSignInfoMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostWalletPreTransactionSignInfoResponse,
    TPostWalletPreTransactionSignInfoParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletPreTransactionSignInfo', 'Post'],
    mutationFn: (params?: TPostWalletPreTransactionSignInfoParams) =>
      postWalletPreTransactionSignInfo(params, mutationOptions?.meta?.requestOptions),
  })
}

// Gas Price
export const usePostWalletPreTransactionGasPriceMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostWalletPreTransactionGasPriceResponse,
    TPostWalletPreTransactionGasPriceParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletPreTransactionGasPrice', 'Post'],
    mutationFn: (params?: TPostWalletPreTransactionGasPriceParams) =>
      postWalletPreTransactionGasPrice(params, mutationOptions?.meta?.requestOptions),
  })
}

// Gas Limit
export const usePostWalletPreTransactionGasLimitMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostWalletPreTransactionGasLimitResponse,
    TPostWalletPreTransactionGasLimitParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletPreTransactionGasLimit', 'Post'],
    mutationFn: (params?: TPostWalletPreTransactionGasLimitParams) =>
      postWalletPreTransactionGasLimit(params, mutationOptions?.meta?.requestOptions),
  })
}

// Nonce
export const usePostWalletPreTransactionNonceMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostWalletPreTransactionNonceResponse,
    TPostWalletPreTransactionNonceParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletPreTransactionNonce', 'Post'],
    mutationFn: (params?: TPostWalletPreTransactionNonceParams) =>
      postWalletPreTransactionNonce(params, mutationOptions?.meta?.requestOptions),
  })
}

// SUI Object
export const usePostWalletPreTransactionSuiObjectMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostWalletPreTransactionSuiObjectResponse,
    TPostWalletPreTransactionSuiObjectParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletPreTransactionSuiObject', 'Post'],
    mutationFn: (params?: TPostWalletPreTransactionSuiObjectParams) =>
      postWalletPreTransactionSuiObject(params, mutationOptions?.meta?.requestOptions),
  })
}

// 地址校验
export const usePostWalletPreTransactionValidateAddressMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostWalletPreTransactionValidateAddressResponse,
    TPostWalletPreTransactionValidateAddressParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletPreTransactionValidateAddress', 'Post'],
    mutationFn: (params?: TPostWalletPreTransactionValidateAddressParams) =>
      postWalletPreTransactionValidateAddress(params, mutationOptions?.meta?.requestOptions),
  })
}

// 交易广播
export const usePostWalletPreTransactionBroadcastTransactionMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostWalletPreTransactionBroadcastTransactionResponse,
    TPostWalletPreTransactionBroadcastTransactionParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletPreTransactionBroadcastTransaction', 'Post'],
    mutationFn: (params?: TPostWalletPreTransactionBroadcastTransactionParams) =>
      postWalletPreTransactionBroadcastTransaction(params, mutationOptions?.meta?.requestOptions),
  })
}

// 查广播订单列表
export const usePostWalletPostTransactionOrdersMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostWalletPostTransactionOrdersResponse,
    TPostWalletPostTransactionOrdersParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['wallet', 'WalletPostTransactionOrders', 'Post'],
    mutationFn: (params?: TPostWalletPostTransactionOrdersParams) =>
      postWalletPostTransactionOrders(params, mutationOptions?.meta?.requestOptions),
  })
}
